import React, { useEffect } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { insertTransaction } from "../../apis/api/NMMBusinessApi";
import { companyList } from "../../apis/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import Lodderr from "../Lodder/Lodder";
import Cookies from "js-cookie"
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const ViewBusinessImpact = () => {
  const {
    handleSubmit,
    control,
    reset,
    register,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(companyList());
  }, [dispatch]);
  
  const navigate = useNavigate();
  const { CompanyList } = useSelector((state) => state.DataSlice);

  const { loading } = useSelector((state) => state.NmmBuisness);

  const transactionModes = [
    { value: "Online", label: "Online" },
    { value: "Offline", label: "Offline" },
  ];

  const user=JSON.parse(Cookies.get('user'));
  const company_id=Cookies.get('company_id');

  const matchValue = company_id+':'+user.company_name;


const updatedOptions = CompanyList.filter(item => item.value !== matchValue);

  const fromCompanyList = [
    { value: company_id+':'+user.company_name, label: user.company_name },
  ];


  const onSubmit = async (data) => {
  
    const response= await dispatch(insertTransaction(data));
 
    if(response.payload.status=='success'){
      toast.success(response.payload.message);
      reset();
      navigate('/Businessimpact')

    }else if(response.payload.status=='error'){
      toast.error(response.payload.message);
    }

  };
  
  return (
    <>
      {loading && <Lodderr />}
      <div className="card card-theme card-outline shadow-sm">
        <div className="container-fluid bg-white mt-4">
          <form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
            <h5>Member to Member Transaction</h5>
            <hr />

            <div className="col-md-6">
              <label className="form-label">
                To Company Name <span className="text-danger">*</span>
              </label>
              <Controller
                name="To_Company_Name"
                control={control}
                rules={{ required: "Please select a company" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={updatedOptions}
                    placeholder="Select Company"
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    value={updatedOptions.find((c) => c.value === field.value)}
                    onChange={(selected) => field.onChange(selected?.value)}
                  />
                )}
              />
              {errors.To_Company_Name && (
                <small className="text-danger">
                  {errors.To_Company_Name.message}
                </small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                From Company Name <span className="text-danger">*</span>
              </label>
              <Controller
                name="From_Company_Name"
                control={control}
                rules={{ required: "Please select a company" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={fromCompanyList}
                    placeholder="Select Company"
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    value={
                      fromCompanyList.find((c) => c.value === field.value) || null
                    }
                    onChange={(selected) => field.onChange(selected?.value)}
                  />
                )}
              />
              {errors.From_Company_Name && (
                <small className="text-danger">
                  {errors.From_Company_Name.message}
                </small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Transaction Mode <span className="text-danger">*</span>
              </label>
              <Controller
                name="Transaction_Mode"
                control={control}
                rules={{ required: "Please select a transaction mode" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={transactionModes}
                    placeholder="Select Transaction Mode"
                    value={
                      transactionModes.find((c) => c.value === field.value) || null
                    }
                    onChange={(selected) => field.onChange(selected?.value)}
                  />
                )}
              />
              {errors.Transaction_Mode && (
                <small className="text-danger">
                  {errors.Transaction_Mode.message}
                </small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Amount <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Amount"
                {...register("Amount", {
                  required: "Amount is required",
                  min: { value: 1, message: "Amount must be greater than 0" },
                  pattern: {
                    value: /^[0-9]+(\.[0-9]{1,2})?$/,
                    message: "Enter a valid amount",
                  },
                })}
              />
              {errors.Amount && (
                <small className="text-danger">{errors.Amount.message}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Transaction Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                {...register("Transaction_Date", {
                  required: "Transaction date is required",
                  validate: (value) => {
                    const today = new Date().toISOString().split("T")[0];
                    return (
                      value >= today || "Transaction date cannot be in the past"
                    );
                  },
                })}
              />
              {errors.Transaction_Date && (
                <small className="text-danger">
                  {errors.Transaction_Date.message}
                </small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Amount"
                {...register("Password", {
                  required: "Password is required",
                 minLength:{
                   value:6,
                  message:"Password must be at least 6 characters"
                 }
                })}
              />
              {errors.Password && (
                <small className="text-danger">{errors.Password.message}</small>
              )}
            </div>

            <div className="col-md-12">
              <label className="form-label">
                Comment <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter Comment"
                {...register("Comment", {
                  required: "Comment is required",
                  minLength: {
                    value: 10,
                    message: "Comment must be at least 10 characters long",
                  },
                })}
              ></textarea>
              {errors.Comment && (
                <small className="text-danger">{errors.Comment.message}</small>
              )}
            </div>

            <div className="col-md-12 mt-3">
              <button type="submit" className="btn btn-primary float-end">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ViewBusinessImpact;
